module.exports = __webpack_public_path__ + "static/media/gp3.0a371f64.webp";